const ToggleField = ({ title, checked, fieldKey, onChange }) => {
  return (
    <div className="flex items-center justify-between p-3 bg-white">
      <span className="text-sm font-medium">{title}</span>

      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(fieldKey, e.target.checked)}
          className="sr-only peer"
        />
        <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-[#4CAF50] transition-all"></div>
        <div className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full peer-checked:translate-x-5 transition"></div>
      </label>
    </div>
  );
};

export default ToggleField;